import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useApolloClient } from 'react-apollo';
import { getGoogleCalendarConsentContexts } from '@kiper/account-graphql/google-calendar/query';
import { CONSENT_STATUS } from '../constants';
import { readSessionFromHash } from '../utils';

const useConsentSession = () => {
  const history = useHistory();
  const client = useApolloClient();

  const [session, setSession] = useState('');
  const [email, setEmail] = useState('');
  const [contexts, setContexts] = useState([]);
  const [selectedOptionId, setSelectedOptionId] = useState('');
  const [status, setStatus] = useState(CONSENT_STATUS.loading);

  useEffect(() => {
    const hashSession = readSessionFromHash();

    if (!hashSession) {
      setStatus(CONSENT_STATUS.expired);
      return undefined;
    }

    setSession(hashSession);
    history.replace('/calendar/select-context');

    let active = true;

    client
      .query({
        query: getGoogleCalendarConsentContexts,
        variables: { session: hashSession },
        fetchPolicy: 'network-only',
      })
      .then(({ data: response }) => {
        if (!active) return;

        const data = response && response.getGoogleCalendarConsentContexts;
        const options = (data && data.contexts) || [];
        const current = options.find(option => option.isCurrent) || options[0];

        setEmail((data && data.email) || '');
        setContexts(options);
        setSelectedOptionId(current ? current.optionId : '');
        setStatus(CONSENT_STATUS.ready);
      })
      .catch(() => {
        if (!active) return;

        setStatus(CONSENT_STATUS.expired);
      });

    return () => {
      active = false;
    };
  }, [client, history]);

  return {
    session,
    email,
    contexts,
    selectedOptionId,
    setSelectedOptionId,
    status,
    setStatus,
  };
};

export default useConsentSession;
